import styled, { css } from "styled-components";
import { media } from "../styles/media"; // 생성한 미디어 쿼리 헬퍼 가져오기


/******************************************************************/
/********************* 지역/사이트/그룹 선택 탭 *********************/
/******************************************************************/

// 선택 박스 프레임
/**
 * 
 */
export const SelectorBoxFrame = styled.div`
    /* 모바일 기본 */
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;

    border-radius: 8px;
    border: 1px solid var(--Grayscale-GR_F1, #F1F1F1);
    background: var(--Grayscale-WT_FF, #FFF);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 280px;
        border-radius: 12px;

        /* 🔑 절대 배치 유지 */
        position: absolute;     

        /* 🔑 부모(SheetListFrame) 기준 위치 설정 */
        top: calc(-250/1920 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 선택 박스 목록 프레임
export const SelectorFieldFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    // width: 320px;
    height: 56px;
    padding: 16px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;

    /* 태블릿 배치 */
    ${media.tablet`
        // width: 376px;
        width: 280px;
        height: 75px;
        padding: 15px 20px;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 선택 목록 Row 영역
export const SelectorRow = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 320px;
    height: 56px;
    // padding: 16px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // gap: 16px;

    background: var(--Grayscale-WT_FF, #FFF);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 250px;
        align-items: flex-start;
        align-self: stretch;
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}      
`;

// 선택 목록 프레임
export const SelectorFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;    

    /* 태블릿 배치 */
    ${media.tablet`
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 12px;
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}      
`;

// 선택 목록 뱃지
export const SelectorBadge = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 44px;
    padding: 3px 3.5px 4px 3.5px;
    justify-content: center;
    align-items: center;
    align-self: stretch;

    border-radius: 10px;
    background: var(--GrayPurple, #6C739A);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 56px;
        padding: 3px 6.4px 5px 6.4px;
        border-radius: 12px;
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}      
`;

// 선택 목록 뱃지 텍스트
export const SelectorBadgeText = styled.span`
    /* 모바일 기본 */
    width: 37px;
    height: 13px;
    flex-shrink: 0;

    overflow: hidden;
    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;

    /* 태블릿 배치 */
    ${media.tablet`
        display: -webkit-box;
        width: 43.2px;
        
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        align-self: stretch;

        font-size: 9px;
        font-weight: 450;
    `}   
    
    /* Desktop 배치 */
    ${media.desktop`
        width: 48.2px;    
        font-size: 12px;
        font-weight: 500;        
    `}      
`;

// 선택 목록 텍스트
export const SelectorText = styled.div`
    /* 모바일 기본 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Grayscale-GR_A7, #A7A7A7);
    text-overflow: ellipsis;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    /* 태블릿 배치 */
    ${media.tablet`
        align-self: stretch;

        font-size: 20px;
        font-weight: 450;
        line-height: 22px;
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 22px;
        font-weight: 500;
        line-height: 24px;
    `}    
`;
export const SelectorTextSet = styled.div`
    /* 모바일 기본 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Grayscale-BK_00, #000);
    text-overflow: ellipsis;

    /* mobile/body1_B */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`
        align-self: stretch;

        font-size: 18px;
        line-height: 22px; /* 120% */
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
        line-height: 24px; /* 120% */
    `}    
`;


// 선택 사이 밑줄 프레임
export const SelectorSpaceFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    padding: 0 1px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;

    /* 태블릿 배치 */
    ${media.tablet`
        height: 1px;
        padding: 0 1.2px;
    `}    
	
    /* Desktop 배치 */
    ${media.desktop`
        height: 2px;
        padding: 0 2.2px;
    `}    
`;

// 선택 사이 밑줄
export const SelectorSpace = styled.div`
    /* 모바일 기본 */
    height: 1px;
    align-self: stretch;

    background: var(--Grayscale-GR_F7, #F7F7F7);

    /* 태블릿 배치 */
    ${media.tablet`
        height: 1.2px;
        flex-shrink: 0;
    `}    
	
    /* Desktop 배치 */
    ${media.desktop`
        height: 1.6px;
    `}    
`;

// only tablet, desktop
export const SelectorFocus = styled.div`
    width: 376px;
    height: 92px;
    flex-shrink: 0;

    border-radius: 12px;
    border: 2px solid var(--Blue, #3379EB);

    /* 태블릿 배치 */
    ${media.tablet`

    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

/******************************************************************/
/************************* 선택 목록 모달  *************************/
/******************************************************************/

// 선택 목록 프레임
/**
 * 
 */
export const SheetListFrame = styled.div`
    /* 모바일 기본 */
    display: inline-flex;
    flex-direction: column;
    align-items: center;

    border-radius: 28px 28px 0 0;
    background: var(--Grayscale-WT_FF, #FFF);

    /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
    position: relative;     

    /* 🔑 Flexbox를 사용해 내부 요소 배치 */
    display: flex;
    flex-direction: column; /* 세로 방향으로 요소 배치 */
    // justify-content: flex-end; /* 아래쪽으로 요소를 몰아넣음 */    
    align-items: center; /* 가운데 정렬 */  

    /* 태블릿 배치 */
    ${media.tablet`
        display: flex;
        align-items: flex-start;
        flex-shrink: 0;
        
        border-radius: 12px;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 선택 목록 타이틀 프레임
export const SheetListTitleFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 400px;
    height: 72px;
    padding: 30px 0 18px 0;
    justify-content: center;
    align-items: center;

    border-radius: 16px 16px 0 0;
    background: var(--Grayscale-WT_FF, #FFF);

    /* 태블릿 배치 */
    ${media.tablet`
        padding: 20px 200px 20px 40px;
        align-self: stretch;
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}       
`;

// 선택 목록 타이틀 텍스트
export const SheetListTitleText = styled.div`
    /* 모바일 기본 */
    color: var(--Grayscale-BK_00, #000);
    text-align: center;

    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 26px;
        line-height: 34px; /* 121.429% */
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 28px;
    `}     
`;

// 선택 영역 스크롤 프레임
export const SheetListScrollFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 360px;
    padding-bottom: 36px;
    flex-direction: column;
    align-items: center;

    // border-radius: 16px 16px 0 0;
    // background: var(--Grayscale-WT_FF, #9c4646ff);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 460px;
        padding: 8px 40px;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;
        align-self: stretch;
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 선택 영역 스크롤 서브 프레임
// 보류
export const SheetListScrollSubFrame = styled.ul`
    /* 모바일 기본 */
    display: flex;
    width: 360px;
    flex-direction: column;
    align-items: flex-start;

    // border-radius: 16px 16px 0 0;
    // background: var(--Grayscale-WT_FF, #9c4646ff);

    /* 태블릿 배치 */
    ${media.tablet`
        display: flex;
        width: 440px;
        flex-direction: column;
        align-items: flex-start;
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 28px;
    `}        
`;

// 목록 선택
export const SheetListSelect = styled.li`
    /* 모바일 기본 */
    display: flex;
    height: 56px;
    padding: 4px 12px;
    justify-content: center;
    align-items: center;
    align-self: stretch;

    /* 태블릿 배치 */
    ${media.tablet`
        height: 72px;
        // padding: 24px 56px 24px 28px;

        padding: 8px 12px;
        align-items: flex-start;
        gap: 10px;

    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 28px;
    `}        
`;

// 보류
export const SheetListSelectButton = styled.div`
    /* 모바일 기본 */
    display: flex;
    height: 56px;
    padding: 4px 12px;
    justify-content: center;
    align-items: center;
    align-self: stretch;

    ${media.tablet`
        /* 태블릿 배치 */

    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}       
`;

// 목록 포커스 프레임
export const SheetListSelectFocusFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 336px;
    padding: 12px 8px 12px 12px;
    align-items: center;

    border-radius: 4px;
    background: var(--Blue_op8, rgba(51, 121, 235, 0.08));

    /* 태블릿 배치 */
    ${media.tablet`
        padding: 12px 12px 12px 16px;
        flex: 1 0 0;
        align-self: stretch;
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}       
`;

// 목록 포커스 텍스트
export const SheetListSelectTextFocus = styled.span`
    /* 모바일 기본 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Blue, #3379EB);
    text-overflow: ellipsis;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 18px;
        font-weight: 500;
        line-height: 20px; /* 120% */
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
        font-weight: 500;
        line-height: 24px; /* 120% */
    `}      
`;

// 목록 체크 아이콘
export const SheetListSelectCheckIcon = styled.span<{ $imgUrl: string}>`
    /* 모바일 기본 */
    width: 24px;
    height: 24px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$imgUrl}); 

    /* 태블릿 배치 */
    ${media.tablet`

    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}     
`;

// 목록 언 포커스 프레임
export const SheetListSelectUnFocusFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 336px;
    padding: 12px 8px 12px 12px;
    align-items: center;

    /* 태블릿 배치 */
    ${media.tablet`
        padding: 12px 12px 12px 16px;
        flex: 1 0 0;
        align-self: stretch;
    `}  

    /* Desktop 배치 */
    ${media.desktop`

    `}      
`;

// 목록 언 포커스 텍스트
export const SheetListSelectTextUnFocus = styled.span`
    /* 모바일 기본 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Grayscale-GR_22, #222);
    text-overflow: ellipsis;

    /* mobile/body1_M */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 18px;
        font-weight: 500;
        line-height: 20px; /* 120% */
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
        font-weight: 500;
        line-height: 24px; /* 120% */
    `}      
`;

// 목록 선택 버튼 프레임
export const SheetListButtonFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    padding: 16px 20px;
    justify-content: center;
    align-items: center;

    background: var(--Grayscale-WT_FF, #FFF);

    /* 태블릿 배치 */
    ${media.tablet`
        display: flex;
        padding: 20px 40px;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        align-self: stretch;
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}      
`;

// 보류
export const SheetListButtonSubFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    align-items: flex-start;
    gap: 8px;

    /* 태블릿 배치 */
    ${media.tablet`
        display: flex;
        height: 60px;
        align-items: flex-start;
        gap: 8px;
    `}    

    /* Desktop 배치 */
    ${media.desktop`
    
    `}       
`;

// 목록 선택 취소 버튼
export const SheetListCancelButton = styled.button`
    /* 모바일 기본 */
    display: flex;
    width: 156px;
    height: 52px;
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 4px;
    background: var(--GrayPurple, #6C739A);

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */

    /* 🔑 마우스를 눌렀을 때 (Press 상태) */
    &:active {
        background: var(--Grayscale-WT_FF, #FFF);
        color: var(--Grayscale-GR_45, #454545);
    }

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 20px;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 22px;
        font-weight: 600;
        line-height: 28px; /* 116.667% */    
    `}        
`;

// 목록 선택 완료 버튼
export const SheetListConfirmButton = styled.button`
    /* 모바일 기본 */
    display: flex;
    width: 156px;
    height: 52px;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 4px;
    background: var(--GrayPurple, #6C739A);

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */

    /* 🔑 마우스를 눌렀을 때 (Press 상태) */
    &:active {
        background: var(--Grayscale-WT_FF, #FFF);
        color: var(--Grayscale-GR_45, #454545);
    }

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 20px;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 22px;
        font-weight: 600;
        line-height: 28px; /* 116.667% */    
    `}        
`;


/******************************************************************/
/********************* 선택 목록 토스트 메시지  *********************/
/******************************************************************/

// 토스트 메시지 프레임
export const ToastFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 320px;
    padding: 12px;
    justify-content: center;
    // align-items: flex-end;
    gap: 10px;
    border-radius: 12px;
    background: var(--DarkNavy_op60, rgba(27, 31, 56, 0.60));

    /* 🔑 절대 배치 유지 */
    position: absolute;   

    margin-left: 4vw;
    // left: calc(50/1440 * 100%);
    bottom: calc(-1000/1020 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        display: inline-flex;
        padding: 20px;
        gap: 16px;

        border-radius: 14px;

        /* 🔑 부모(SheetListFrame) 기준 위치 설정 */
        // top: calc(450/1020 * 100%);
        // left: calc(10/1440 * 100%);
        // bottom: calc(5/1020 * 100%);    
        // bottom: calc(-405/1020 * 100%);    
        margin-left: 35vw;
        margin-bottom: 20vh;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        margin-left: 40vw;
    `}        
`;

// 토스트 메시지
export const ToastText = styled.div`
    /* 모바일 기본 */
    width: 300px;

    flex-shrink: 0;
    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 114.286% */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 380px;

        font-size: 20px;
        font-weight: 400;
        line-height: 24px; /* 120% */
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 22px;
        font-weight: 400;
        line-height: 24px; /* 120% */    
    `}        
`;

